export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-android-1.34f9ec82.svg";